import { css } from '@emotion/react'

import { useEffect, useState } from 'react'

import { heightButton, focusVisible } from '@/styles/mixins'
import { mediaUp } from '@/styles/media'
import { ButtonTextStyles } from '@/styles/typography'
import { border, colors, transitions, weights } from '@/styles/theme'

interface Props {
  href: string
  text: string
}

function ButtonDownload(props: Props) {
  const { href, text } = props
  const [isIOS, setIsIOS] = useState(false)

  useEffect(() => {
    const userAgent = window.navigator.userAgent
    const isIOS = userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)

    setIsIOS(!!isIOS)
  }, [])

  return isIOS ? (
    <a css={button} href={href} target="_blank" rel="noreferrer">
      {text}
    </a>
  ) : (
    <a css={button} href={href} download target="_blank" rel="noreferrer">
      {text}
    </a>
  )
}

const button = css`
  ${focusVisible};
  ${ButtonTextStyles};
  ${heightButton};
  margin-top: 18px;

  position: relative;
  color: ${colors.white};
  background-color: ${colors.darkSkyBlue};
  border-radius: ${border.radius};
  transition: background-color ${transitions.base};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${weights.black};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;

  &[disabled] {
    background-color: ${colors.cloudyBlue};
  }

  &:not([disabled]) {
    &:hover,
    &:focus-visible {
      background-color: ${colors.blueHover};
    }
  }

  ${mediaUp('lg')} {
    margin-top: 40px;
  }
`

export default ButtonDownload
